import { render, staticRenderFns } from "./SampleReports.vue?vue&type=template&id=27d00716&scoped=true&"
import script from "./SampleReports.vue?vue&type=script&lang=ts&"
export * from "./SampleReports.vue?vue&type=script&lang=ts&"
import style0 from "./SampleReports.vue?vue&type=style&index=0&id=27d00716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d00716",
  null
  
)

export default component.exports